import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import LoadingPage from "../../../Components/layouts/loading";
import CustomInput from "../../../CustomComponent/custom_input";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import FormSubmitButton from "../../../Components/layouts/formSubmitButton";
import { SocietyOnboardingInfo } from "../../../SchemaInfo/info";
import { SocietyOnboardingScheama } from "../../../Schemas/Society Onboarding/societyOboardingSchema";
import StepRoutes from "../../../Routes/steps_routes";
import { FcOrganization } from "react-icons/fc";
import performRequest from "../../../api/request";
import { Toast } from "../../../CustomComponent/toast";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
// import { useSelector } from "react-redux";
import { useParams } from "react-router";
import { useEffect } from "react";

const EditSocietyOnboarding = () => {
  const [loading, setLoading] = useState(false);
  const [societyInfo, setSocietyInfo] = useState(SocietyOnboardingInfo);
  const navigate = useNavigate();
  let { id } = useParams();

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/society/get-societyOnboarding-byId/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setSocietyInfo(res.data);
        } else {
          Toast("error", "Error while getting updates!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  const handelSubmit = (values) => {
    setLoading(true);
    performRequest(
      "PATCH",
      `/society/edit-societyOnboarding-byId/${id}`,
      values
    )
      .then((res) => {
        if (res.status === 200) {
          Toast("success", "Society edited successfully!");
          navigate(`/view-society-onboardings/${id}`);
        } else {
          Toast("error", "Error while uploading");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xxl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcOrganization />
                  Society Onboard
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-md-12">
              <div className="card">
                <div className="card-header">
                  <h2 className="page-title"> Edit Society Details</h2>
                </div>
                <Formik
                  initialValues={societyInfo}
                  onSubmit={handelSubmit}
                  validationSchema={SocietyOnboardingScheama}
                >
                  {(props) => (
                    <Form>
                      <div className="card-body">
                        <div className="mb-3 row">
                          <label className="form-label required">
                            Society Name
                          </label>
                          <CustomInput name="societyName" type="text" />
                          {props.touched?.societyName &&
                            props.errors?.societyName && (
                              <p className="text-danger">
                                {props.errors?.societyName}
                              </p>
                            )}
                        </div>
                        <div className="mb-3 row">
                          <div className="mb-3 col-md-4 col-lg-4 col-12">
                            <label className="form-label required">
                              Society Contact Number
                            </label>
                            <CustomInput name="phone" type="text" />
                            {props.touched?.phone && props.errors?.phone && (
                              <p className="text-danger">
                                {props.errors?.phone}
                              </p>
                            )}
                          </div>
                          <div className="mb-3 mb-3 col-md-4 col-lg-4 col-12">
                            <label className="form-label required">State</label>
                            <CustomInput name="state" type="text" />
                            {props.touched?.state && props.errors?.state && (
                              <p className="text-danger">
                                {props.errors?.state}
                              </p>
                            )}
                          </div>

                          <div className="mb-3 mb-3 col-md-4 col-lg-4 col-12">
                            <label className="form-label">Pincode</label>
                            <CustomInput name="pincode" type="text" />
                            {props.touched?.pincode &&
                              props.errors?.pincode && (
                                <p className="text-danger">
                                  {props.errors?.pincode}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row w-100 d-flex">
                          <div className="mb-3 mb-3 col-md-4 col-lg-4 col-12">
                            <label className="form-label required">City</label>
                            <CustomInput name="city" type="text" />
                            {props.touched?.city && props.errors?.city && (
                              <p className="text-danger">
                                {props.errors?.city}
                              </p>
                            )}
                          </div>

                          <div className="mb-3 mb-3 col-md-4 col-lg-4 col-12">
                            <label className="form-label required">
                              Country
                            </label>
                            <CustomInput name="country" type="text" />
                            {props.touched?.country &&
                              props.errors?.country && (
                                <p className="text-danger">
                                  {props.errors?.country}
                                </p>
                              )}
                          </div>

                          <div className="mb-3 mb-3 col-md-4 col-lg-4 col-12">
                            <label className="form-label ">
                              Num Of People Size
                            </label>
                            <CustomInput name="numofPeopleSize" type="text" />
                            {props.touched?.numofPeopleSize &&
                              props.errors.numofPeopleSize && (
                                <p className="text-danger">
                                  {props.errors?.numofPeopleSize}
                                </p>
                              )}
                          </div>
                        </div>

                        <div className="mb-3 row">
                          <label className="form-label ">Address Line 1</label>
                          <CustomInput name="addressLine1" type="text" />
                          {props.touched?.addressLine1 &&
                            props.errors?.addressLine1 && (
                              <p className="text-danger">
                                {props.errors?.addressLine1}
                              </p>
                            )}
                        </div>

                        <div className="mb-3 row">
                          <label className="form-label required">
                            Address Line 2
                          </label>
                          <CustomInput name="addressLine2" type="text" />
                          {props.touched?.addressLine2 &&
                            props.errors?.addressLine2 && (
                              <p className="text-danger">
                                {props.errors?.addressLine2}
                              </p>
                            )}
                        </div>
                      </div>
                      <div className="card-footer">
                        <div className="btn-list justify-content-end">
                          <FormSubmitButton buttonText="Edit Society" />
                          <SimpleButton buttonText="Cancel" type="secondary" />
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default EditSocietyOnboarding;
